<template>
  <div class="industry-sectors-wrapper">
    <h1>Industry classification settings</h1>
    <div style="margin: 20px 0;">
      <input
        type="text"
        class="form-item form-item--input"
        style="max-width: 300px;"
        placeholder="Filter"
        v-model="search" />
    </div>
    <table class="industry-settings-table">
      <thead>
        <tr>
          <td
            class="sorting-buttons"
            :class="[sort]"
            @click="changeSort">Industry sectors</td>
          <td>Icon</td>
          <td>Activity sectors</td>
          <td>Controls</td>
        </tr>
      </thead>
      <tbody>
        <settings-row
          v-for="item in filteredTree"
          :key="item.id"
          :value="item" />
      </tbody>
    </table>
    <div class="main-btns-wrapper">
      <button class="btn btn-blue" @click="development">Import CSV</button>
      <button class="btn btn-blue" @click="exportToCSV">Export CSV</button>
      <button class="btn btn-blue" @click="showModal">Add</button>
      <button class="btn btn-blue" @click="development">Save</button>
    </div>
    <modal
      name="adding-modal"
      class="adding-modal"
      @closed="renderAdding = false"
      :click-to-close="isAddingCanBeClosed">
      <add-modal
        :avalible-options="flattedFields"
        v-if="renderAdding" />
    </modal>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'IndustrySectorSettingsLayout',
  components: {
    'settings-row': () => import('./industryRow.vue'),
    'add-modal': () => import('./AddNewSectorModal.vue'),
  },
  data: () => ({
    sectorsTree: Array(),
    sort: 'desc',
    search: '',
    renderAdding: false,
    isAddingCanBeClosed: true,
  }),
  computed: {
    sortedTree() {
      return [...this.sectorsTree].sort((a, b) => {
        return this.sort === 'desc' ? a.label.localeCompare(b.label) : b.label.localeCompare(a.label);
      });
    },
    filteredTree() {
      const tempFunc = (item) => item.label.toUpperCase().includes(this.search.toUpperCase());

      return this.search.length > 0
        ? this.sortedTree.filter(
          (sector) => tempFunc(sector) || sector.children.some((item) => tempFunc(item))
        )
        : this.sortedTree;
    },
    flattedFields() {
      /**
       * Gotta all unique fields names from tree and make it into
       * string[] with one-dimention.
       */
      const recurced = (tree) => {
        return tree.reduce((acc, item) => item.children && item.children.length > 0
          ? [...acc, item.label, ...recurced(item.children)]
          : [...acc, item.label], Array());
      };
      return this.sectorsTree.reduce((acc, tree) => tree.children && tree.children.length > 0
        ? [...acc, ...recurced(tree.children)]
        : acc, Array()).filter((item, index, arr) => arr.indexOf(item) === index).sort();
    },
  },
  methods: {
    changeSort() {
      this.sort = this.sort === 'asc' ? 'desc' : 'asc';
    },
    showModal() {
      this.renderAdding = true;
      this.$modal.show('adding-modal');
    },
    handleClose() {

    },
    exportToCSV() {
      const maxChilds = this.sectorsTree.reduce((acc, item) => {
        return item.children.length > acc ? item.children.length : acc;
      }, 0);

      const csvArr = this.sectorsTree.reduce((acc, item) => {
        const row = [item.label, ...Array(maxChilds).fill('').map((el, index) => {
          return item.children[index] ? item.children[index].label : el;
        })];
        return [...acc, row];
      }, []);

      csvArr.unshift(['Industry Sector', ...Array(maxChilds).fill('Activity sector')]);

      const csvText = csvArr.map((row) => {
        return row.map((col) => `"${col}"`).join(';');
      }).join('\n');

      const csvFile = new Blob([csvText], {
        type: 'text/csv',
      });
      const tempLink = document.createElement('a');
      const csvUrl = URL.createObjectURL(csvFile);
      tempLink.href = csvUrl;
      tempLink.download = 'IndustrySectors.csv';
      tempLink.click();
      setTimeout(() => {
        URL.revokeObjectURL(csvUrl);
      }, 200);
    },
    development() {
      this.$root.$emit('notification', {
        message: 'In development',
        type: 'attention',
        show: true,
      });
    },
  },
  created() {
    this.$store.dispatch('GET_INDUSTRY_TREE').then((data) => {
      this.sectorsTree = [...data];
    });
  },
});
</script>

<style lang="scss">
  .page-content-wrapper {
    background: #fff;
  }
  .industry-sectors-wrapper {
    padding-bottom: 40px;
  }
  .main-btns-wrapper {
    display: flex;
    flex-flow: row wrap;
    margin-top: 30px;

    >.btn {
      margin-right: 10px;
    }
  }
  .industry-settings-table {
    border-collapse: collapse;
    thead {
      font-weight: bold;
    }
    td {
      padding: 10px 13px;
      border: 1px solid #ddd;
    }
  }
</style>
